module.exports = __webpack_public_path__ + "media/design_video_1.6b33ea64.mp4";